import { Col, Row } from 'antd';

import sortByKey from 'utils/sortByKey';
import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import { addDefaultNutrient } from 'pages/product-full-view/components/product-media-area/nutrition-label/add-label/pet-nutrition-label/utils';

import 'pages/product-full-view/components/product-media-area/nutrition-label/add-label/pet-nutrition-label/PetNutritionFacts.less';
import { SnapshotHighlightText } from '../WrapperNutrient';

const PetNutritionFacts = ({ currentData, nutrients, previousData }) => {
  const {
    fat,
    protein,
    carbohydrate,
    caloriesPerCup,
    calorieContent,
    measurementPerCup,
    measurementUomPerCup,
    enzymesAndMicroorganisms,
    nutritionalAdequacyStatement,
  } = currentData;

  const sortedNutrient = addDefaultNutrient({ nutrients });
  const hasCaloriesStatement =
    fat || protein || carbohydrate || calorieContent || caloriesPerCup;
  const renderFrom = [
    ...(protein ? [`Protein ${protein}`] : []),
    ...(fat ? [`Fat ${fat}`] : []),
    ...(carbohydrate ? [`Carbohydrate ${carbohydrate}`] : []),
  ];

  return (
    <div class='pet-nutrition-facts'>
      <h1 className='pet-nutrition-facts__label'>Pet Nutrition Facts</h1>
      <SeparatorBar />
      <div className='pet-nutrition-facts__measurement'>
        <SnapshotHighlightText
          label={['measurementPerCup', 'measurementUomPerCup']}
          currentValue={currentData}
          snapshotValue={previousData}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>1 cup (8 oz standard measuring cup) =</span>
            <span>
              {measurementPerCup}
              {measurementUomPerCup}
            </span>
          </div>
        </SnapshotHighlightText>
      </div>
      <SeparatorBar height={7} />
      {hasCaloriesStatement && (
        <>
          <SnapshotHighlightText
            label={[
              'fat',
              'protein',
              'carbohydrate',
              'calorieContent',
              'caloriesPerCup',
            ]}
            currentValue={currentData}
            snapshotValue={previousData}
          >
            <div className='pet-nutrition-facts__calories'>
              <div className='pet-nutrition-facts__calories-content'>
                <p>
                  {calorieContent} {caloriesPerCup}
                </p>
              </div>
              {(protein || carbohydrate || fat) && (
                <p style={{ paddingLeft: 12 }}>
                  From: {renderFrom?.join(', ')}
                </p>
              )}
            </div>
          </SnapshotHighlightText>

          <SeparatorBar height={3} />
        </>
      )}
      <div className='pet-nutrition-facts__nutrient'>
        <Row style={{ borderBottom: '1px solid' }}>
          <Col span={12} style={{ paddingLeft: 4, fontWeight: 700 }}>
            Nutrients
          </Col>
          <Col
            span={7}
            style={{ textAlign: 'right', paddingRight: 4, fontWeight: 700 }}
          >
            Guaranteed
          </Col>
          <Col
            span={5}
            style={{
              textAlign: 'right',
              borderLeft: '1px solid',
              paddingRight: 4,
              fontWeight: 700,
            }}
          >
            Per cup
          </Col>
        </Row>
        <NutrientsLabel nutrients={sortedNutrient} />
      </div>
      {(enzymesAndMicroorganisms || currentData?.fdaLabelFootNote) && (
        <SnapshotHighlightText
          label={['fdaLabelFootNote', 'enzymesAndMicroorganisms']}
          currentValue={currentData}
          snapshotValue={previousData}
        >
          <SeparatorBar height={3} />{' '}
          <div className='pet-nutrition-facts__footnote'>
            {!!currentData?.fdaLabelFootNote && (
              <p>{currentData?.fdaLabelFootNote}</p>
            )}
            <p>{enzymesAndMicroorganisms}</p>
          </div>
        </SnapshotHighlightText>
      )}

      {nutritionalAdequacyStatement && (
        <>
          <SeparatorBar height={3} />
          <SnapshotHighlightText
            label={['nutritionalAdequacyStatement']}
            currentValue={currentData}
            snapshotValue={previousData}
          >
            <div className='pet-nutrition-facts__adequacy-statement'>
              <p>{nutritionalAdequacyStatement}</p>
            </div>
          </SnapshotHighlightText>
        </>
      )}
    </div>
  );
};

export default PetNutritionFacts;

const NutrientsLabel = ({ nutrients }) => {
  return (
    <>
      {sortByKey(nutrients, 'index')?.map((nutrient) => {
        const {
          limit,
          offset,
          quantity,
          guaranteed,
          quantityUom,
          displayName,
          nutrientName,
          guaranteedUom,
          hightLightText,
        } = nutrient;

        return (
          <Row
            style={{
              borderBottom: '1px solid',
              backgroundColor: hightLightText,
            }}
          >
            <Col span={12} style={{ paddingLeft: offset || 4 }}>
              {displayName || nutrientName}{' '}
              <span>{limit ? `(${limit})` : ''}</span>
            </Col>
            <Col
              span={7}
              style={{
                textAlign: 'right',
                paddingRight: 4,
              }}
            >
              <p style={{ wordBreak: 'break-word' }}>
                {guaranteed}
                <span style={{ wordBreak: 'normal' }}>{guaranteedUom}</span>
              </p>
            </Col>
            <Col
              span={5}
              style={{
                textAlign: 'right',
                paddingRight: 4,
                borderLeft: '1px solid',
              }}
            >
              <p style={{ wordBreak: 'break-word' }}>
                {quantity ? (
                  <>
                    {quantity}
                    <span style={{ wordBreak: 'normal' }}>{quantityUom}</span>
                  </>
                ) : null}
              </p>
            </Col>
          </Row>
        );
      })}
    </>
  );
};
